export const TicketIcon = ({ width = 105, height = 156 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill="#525252"
  >
    <path d="m17.975,7.173c-.332-.066-.602-.273-.742-.569-1.552-3.271-5.144-5.099-8.735-4.438-3.271.599-5.837,3.212-6.383,6.501-.162.973-.151,1.945.033,2.89.06.309-.073.653-.346.901C.641,13.514,0,14.949,0,16.5,0,19.532,2.468,22,5.501,22h10.499l1.077-.003c3.872-.295,6.913-3.579,6.923-7.481-.005-3.559-2.54-6.647-6.025-7.343Zm-6.475,12.827c-.828,0-1.5-.672-1.5-1.5s.672-1.5,1.5-1.5,1.5.672,1.5,1.5-.672,1.5-1.5,1.5Zm1.469-6.323c-.165.076-.469.468-.469.823v.5c0,.553-.448,1-1,1s-1-.447-1-1v-.5c0-1.224.839-2.272,1.629-2.638.549-.254,1.039-.919.817-1.777-.126-.49-.54-.904-1.03-1.031-.483-.124-.957-.034-1.333.259-.371.287-.583.72-.583,1.188,0,.553-.448,1-1,1s-1-.447-1-1c0-1.091.495-2.101,1.359-2.77.864-.668,1.978-.894,3.058-.612,1.19.308,2.158,1.276,2.465,2.467.429,1.66-.376,3.381-1.913,4.092Z" />
  </svg>
);
